const BLOCK_TYPES = [
  { key: 2, label: 'Mute' },
  { key: 4, label: 'Mute Chat' },
  { key: 5, label: 'Mute All' },
];

const BLOCK_NO_VOTE = { key: 3, label: 'No Vote' };

const reportOptions = [
  { key: '1', label: 'Improper Use of $ Tag' },
  { key: '2', label: 'Incorrect Writing Standard' },
  { key: '3', label: 'Advertising' },
  { key: '4', label: 'Junk Post' },
  { key: '5', label: 'Spam' },
  { key: '6', label: 'Out of Topic' },
  { key: '7', label: 'Vulgarity' },
  { key: '8', label: 'Abusive Behaviour' },
  { key: '9', label: 'Provoking Other Users' },
  { key: '10', label: 'Inapropriate Username & Photo' },
  { key: '11', label: 'Stocks Cheering' },
];

const BLOCK_DURATION = [
  { label: '1 day', value: '1' },
  { label: '3 days', value: '3' },
  { label: '7 days', value: '7' },
  { label: 'Indefinitely', value: '0' },
];

export { BLOCK_TYPES, BLOCK_NO_VOTE, reportOptions, BLOCK_DURATION };
